import React from 'react';
import cx from 'classnames';

import { useModal } from '~/features/modals/modal-actions';

import formStyles from '~/components/lawns/questionnaire/questionnaire.module.scss';

const FormModalTrigger = ({ className, buttonCopy, modalName, options }) => {
  const { showModal } = useModal();

  return (
    <div className={cx(formStyles.modalTriggerContainer, className)}>
      <button
        type="button"
        className={formStyles.modalButton}
        onClick={() => showModal(modalName, options)}
      >
        {buttonCopy}
      </button>
    </div>
  );
};

export default FormModalTrigger;
